module.exports = __webpack_public_path__ + "media/images/pic04-a7b84eefb3a1e43063549895297a2c37.jpg";